module.exports = __webpack_public_path__ + "static/img/lunbo1.0c4a0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/lunbo1.png
// module id = W76v
// module chunks = 17